import { render, staticRenderFns } from "./ProductPosts.vue?vue&type=template&id=4c1686ba&scoped=true"
import script from "./ProductPosts.vue?vue&type=script&lang=js"
export * from "./ProductPosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1686ba",
  null
  
)

export default component.exports